import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from 'dpl/common/design_system/Button';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import useAnalyticsContext from 'dpl/puppy_search_results/hooks/useAnalyticsContext';

import useSearchFiltering from '../hooks/useSearchFiltering';

export default function MobileFilterButtons({
  className,
  setIsMenuOpen,
  totalItemCount,
  resultsType
}) {
  const { hasFilters, clearFilters } = useSearchFiltering();
  const { sendBreedSearchedAnalytics } = useAnalyticsContext();

  const puppyTitle = totalItemCount === 1 ? 'puppy' : 'puppies';
  const breederTitle = totalItemCount === 1 ? 'breeder' : 'breeders';

  const itemType =
    resultsType === RESULTS_TYPES.PUPPIES ? puppyTitle : breederTitle;

  function handleApplyFilters() {
    setIsMenuOpen();
    sendBreedSearchedAnalytics();
  }
  return (
    <div className={classnames('flex justify-between', className)}>
      <button
        type="button"
        className={classnames('ph6 ph8-sm pv2 font-16 fw-medium mr2', {
          midnight: hasFilters,
          disabled: !hasFilters
        })}
        onClick={clearFilters}
        disabled={!hasFilters}
      >
        Clear filters
      </button>
      <Button
        type="button"
        variant="primary"
        size="small"
        className="font-16"
        onClick={handleApplyFilters}
      >
        Show {totalItemCount} {itemType}
      </Button>
    </div>
  );
}

MobileFilterButtons.propTypes = {
  className: PropTypes.string,
  setIsMenuOpen: PropTypes.func.isRequired,
  totalItemCount: PropTypes.number.isRequired,
  resultsType: PropTypes.string.isRequired
};

MobileFilterButtons.defaultProps = {
  className: null
};
